module.exports = __webpack_public_path__ + "assets/img/btn-detail-f0cc7baa.png";